import { getAuthHeaders, tempMeeApi } from '~/services/api';

export async function inviteProfessionalsToJobs(
  jobIds: string[],
  professionalIds: string[],
  officeId: string,
): Promise<void> {
  const headers = await getAuthHeaders();

  await tempMeeApi.post(
    '/jobs/invites',
    { jobIds, professionalIds },
    {
      headers: {
        ...headers,
        'x-office': officeId,
      },
    },
  );
}
